<div class="position-relative row form-group prop-elems pl-0 pr-0">
  <label class="col-sm-6 col-form-label" for=""
    >{{ 'TABLE_ACTIONS_PERMISSIONS' | translate }}
    <i
      class="fa fa-info-circle field-info"
      showDelay="100"
      hideDelay="100"
      tooltipPosition="bottom"
      tooltipStyleClass="label-tooltip custom-tooltip-properties"
      pTooltip="{{ 'TABLE_ACL_TOOLTIP_CONTENT' | translate }}"
    ></i>
  </label>
  <div class="col-sm-6 p-0 input-ctrl">
    <button
      type="button"
      style="display: flex !important"
      class="btn btn-default p-button-icon-only"
      (click)="openTableAcl()"
    >
      <i class="fa fa-edit pl-0"></i>
    </button>
  </div>
</div>
<p-dialog
  class="form p-dialog table-acl-dialog"
  [(visible)]="showTableAcl"
  *ngIf="showTableAcl"
  header="{{ showPopupLabelPermissions() }}"
  [style]="{ width: '96%', height: '90%', overflow: 'hidden !important' }"
  [draggable]="false"
  [modal]="true"
  appendTo="body"
  [closable]="false"
  [styleClass]="isBetaAccessPrivilegeConsumable ? 'table-acl-dialog beta-access-enabled' : 'table-acl-dialog'"
>
  <ng-template pTemplate="header">
    <div class="header-class">
      <span class="span-head"
        >{{ showPopupLabelPermissions() | translate }}
        <span class="dialog-subheader"> {{ this.currentTableName }}</span>
      </span>
      <span *ngIf="formData.t_type === 'query_view'" class="note-span">{{ 'QUERY_NOTE' | translate }}</span>
    </div>
  </ng-template>
  <div class="acl-card section-table-container">
    <div class="col-12 col-sm-12">
      <div class="table-acl-container">
        <div class="aclHeader">
          <span>{{ 'ACTIONS_PERMISSIONS_SET' | translate }}</span>
          <p-button
            *ngIf="!aclLoader && this.tableAclFormData && !disableField && formData.t_type !== 'query_view'"
            icon="pi pi-plus"
            label="{{ 'ADD_ACTION' | translate }}"
            class="add-custom-action-btn new-btn button-filled"
            [style]="{ float: 'right' }"
            (onClick)="!showLoader && showForm('CREATE')"
          />
        </div>
        <p-table
          [value]="tableAclFormData"
          dataKey="sid"
          class="table"
          [scrollable]="true"
          styleClass="p-datatable-gridlines table-acl"
          tableStyleClass=""
          class="table"
          scrollDirection="both"
          *ngIf="!aclLoader"
          class="pb-5"
          groupRowsBy="applicableFor"
          rowGroupMode="subheader"
          [rowGroupHeaderTemplate]="true"
        >
          <ng-template pTemplate="header">
            <tr *ngIf="this.tableAclFormData">
              <th class="action-column" pFrozenColumn alignFrozen="left"></th>
              <th class="aclDescription-column"></th>
              <th class="aclActiontype-column"></th>
              <!-- <th colspan=" + tableAclFormRolesData.length + ">Roles</th> -->
              <th class="aclRoles-column" *ngFor="let col of tableAclFormRolesData; let rowIndex = index">
                <span *ngIf="rowIndex === 0">Roles</span>
              </th>
              <th class="aclButtons" pFrozenColumn alignFrozen="right"></th>
            </tr>
            <tr *ngIf="this.tableAclFormData">
              <th class="action-column" pFrozenColumn alignFrozen="left">{{ 'ACTION' | translate }}</th>
              <th class="aclDescription-column">{{ 'DESCRIPTION' | translate }}</th>
              <th class="aclActiontype-column">{{ 'ACTION_TYPE' | translate }}</th>
              <th
                *ngFor="let col of tableAclFormRolesData; let rowIndex = index"
                class="container"
                class="aclRoles-column"
                pTooltip="{{ col.shortName }}"
                tooltipPosition="top"
              >
                <div class="roleHeaders d-flex justify-content-between w-100 align-items-center item">
                  <span class="column-name-truncate">{{ col.shortName }}</span>
                  <p-splitbutton
                    styleClass="p-button-text"
                    dropdownIcon="pi pi-ellipsis-v"
                    class="add-btn hidesysgenfields btn-align-right table-acl-splitbutton"
                    (onDropdownClick)="getcolumnItems(rowIndex)"
                    appendTo="body"
                    [model]="columnItems"
                    *ngIf="!disableField && formData.t_type !== 'query_view'"
                  >
                  </p-splitbutton>
                </div>
              </th>
              <th class="aclButtons" pFrozenColumn alignFrozen="right"></th>
            </tr>
          </ng-template>
          <ng-template
            pTemplate="groupheader"
            let-acl
            *ngIf="isDeactivateRecords && curTableType !== 'query_view'"
          >
            <tr pRowGroupHeader style="top: 0px !important; background-color: aliceblue">
              <td colspan="8">
                <div style="width: 100%">
                  <span class="font-bold acl-header">{{ acl.applicableFor | translate }}</span>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-column let-i="rowIndex">
            <tr class="table-acl-row">
              <td class="action-column" pFrozenColumn>
                {{ column.actionName | translate }}
              </td>
              <td class="aclDescription-column">
                {{ column.description }}
              </td>
              <td class="aclActiontype-column">
                <span class="non-editable-type">{{ column.aclActionType | translate }}</span>
              </td>
              <td
                pEditableColumn
                class="aclRoles-column"
                *ngFor="let rolePermission of column.rolesPermissions; let j = index"
              >
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <ng-container>
                      <div class="parentOptions">
                        <div class="childOptions">
                          <p-autocomplete
                            [(ngModel)]="column.rolesPermissions[j].value"
                            (onSelect)="onDropdownChange($event.value, i, j)"
                            appendTo="body"
                            (completeMethod)="onDropdownClick(column.sid)"
                            [dropdown]="true"
                            field="label"
                            [readonly]="true"
                            [disabled]="disableField"
                            [styleClass]="column.rolesPermissions[j].value.label"
                            [forceSelection]="true"
                            [suggestions]="aclOptions"
                          >
                        
                          </p-autocomplete>
                           <span class="conditional" *ngIf="column.rolesPermissions[j].label === 'CONDITIONAL'">
                        <i
                          *ngIf="!disableField"
                          class="fa fa-code-fork qb-icon fork-icon-conditional"
                          (click)="editqb(i, j)"
                          (keyup.enter)="editqb(i, j)"
                          tabindex="0"
                        >
                        </i>
                       
                      </span>
                        </div>
                       
                      </div>
                       <span 
                          (click)="editqb(i, j)" 
                          class="queryName" 
                          *ngIf="column.rolesPermissions[j].querySid"
                          [pTooltip]="queriesMap[column.rolesPermissions[j].querySid]"
                          tooltipPosition="top"
                        >
                          {{ queriesMap[column.rolesPermissions[j].querySid] }}
                     </span>
                    </ng-container>
                  </ng-template>
                  <ng-template pTemplate="output">
                    <div class="d-flex align-items-center">
                      <div [ngClass]="column.rolesPermissions[j].value.label" class="rolesColor">
                        {{ column.rolesPermissions[j].value.label | translate }}
                      </div>
                      <span class="conditional" *ngIf="column.rolesPermissions[j].label === 'CONDITIONAL'">
                        <i
                          *ngIf="!disableField"
                          class="fa fa-code-fork qb-icon fork-icon-conditional"
                          (click)="editqb(i, j)"
                          (keyup.enter)="editqb(i, j)"
                          tabindex="0"
                        >
                        </i>
                       
                      </span>
                    </div>
                     <span 
                          (click)="editqb(i, j)" 
                          class="queryName" 
                          *ngIf="column.rolesPermissions[j].querySid"
                          [pTooltip]="queriesMap[column.rolesPermissions[j].querySid]"
                          tooltipPosition="top"
                        >
                          {{ queriesMap[column.rolesPermissions[j].querySid] }}
                     </span>
                  </ng-template>
                </p-cellEditor>
              </td>
              <td class="text-center action-items aclButtons" pFrozenColumn alignFrozen="right">
                <div class="roleHeaders">
                  <p-splitbutton
                    [model]="rowItems"
                    styleClass="p-button-text action-items"
                    dropdownIcon="pi pi-ellipsis-v"
                    (onDropdownClick)="getRowItems(column.sid)"
                    appendTo="body"
                    *ngIf="!disableField && formData.t_type !== 'query_view'"
                  >
                  </p-splitbutton>
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage" *ngIf="this.tableAclFormData === null">
            <tr class="no-records">
              <td colspan="6" class="text-center">
                {{ 'NO_ROLES_CREATED' | translate }}
              </td>
            </tr>
          </ng-template>
        </p-table>
        <div *ngIf="aclLoader || showLoader" class="spinner-container" appendTo="body">
          <p-progress-spinner></p-progress-spinner>
        </div>
      </div>
    </div>
  </div>
  <ng-template #footer>
    <div class="text-right w-100">
      <button
        type="button"
        class="btn btn-primary cancel-btn button-outlined"
        style="border-radius: 4px !important"
        (click)="closeDialog()"
      >
        {{ 'CLOSE' | translate }}
      </button>
    </div>
  </ng-template>
  <div *ngIf="showQueryBuilder">
    <vb-vs-qb-builder [element]="conditionProperty" [(ngModel)]="conditional" (onSave)="changeQb($event)" (onCancel)="cancelQb($event)" >
    </vb-vs-qb-builder>
  </div>
</p-dialog>

<p-dialog
  class="form p-dialog"
  [(visible)]="addTableAcl"
  header="{{ showPopupLabel(buttonName) | translate }}"
  [style]="{ width: '45%', height: '40%' }"
  [draggable]="false"
  [modal]="true"
  appendTo="body"
  [styleClass]="isBetaAccessPrivilegeConsumable ? 'beta-access-enabled' : ''"
>
  <ng-template pTemplate="header">
    <span class="dialog-header"
      >{{ showPopupLabel(buttonName) | translate }}
      <span class="dialog-subheader" *ngIf="buttonName === 'UPDATE'"> {{ ' : ' + this.currentActionName }}</span>
    </span>
  </ng-template>
  <form [formGroup]="aclForm">
    <div class="form-group row">
      <label class="col-md-3 col-form-label required" for="actionName"
        >{{ 'ACTION_NAME' | translate }}
        <i
          class="fa fa-info-circle field-info"
          showDelay="100"
          hideDelay="100"
          tooltipPosition="bottom"
          tooltipStyleClass="label-tooltip custom-tooltip-properties"
          pTooltip="{{ 'ALPHA_NUMERIC_MSG_ACTION_NAME' | translate }}"
        ></i>
      </label>
      <div class="col-md-9">
        <input
          formControlName="actionName"
          id="actionName"
          type="name"
          class="form-control"
          trim="blur"
          [ngClass]="{ 'error-border': this.messages && this.messages.actionName }"
        />
        <small *ngIf="this.messages && this.messages.actionName" class="input-error-text">
          <span [innerHtml]="this.messages.actionName"></span>
        </small>
      </div>
    </div>
    <div class="form-group row" *ngIf="isDeactivateRecords">
      <label class="col-md-3 col-form-label required" for="applicableFor">{{ 'ACTION_ON' | translate }}</label>
      <div class="col-md-9 d-flex align-items-center applicableForSection">
        <div *ngFor="let option of actionOnOptions" class="field-radiobutton mr-3">
          <p-radiobutton
            formControlName="applicableFor"
            [value]="option.value"
            [ngClass]="{ 'error-border': this.messages && this.messages.applicableFor }"
            [inputId]="option.value"
          >
          </p-radiobutton>
          <label class="mb-0 ml-1 mr-2" [for]="option.value">{{ option.label }}</label>
        </div>
      </div>
      <div class="col-md-9 offset-md-3">
        <small *ngIf="this.messages && this.messages.applicableFor" class="input-error-text">
          <span [innerHtml]="this.messages?.applicableFor"></span>
        </small>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-md-3 col-form-label" for="description">{{ 'DESCRIPTION' | translate }}</label>
      <div class="col-md-9">
        <input formControlName="description" id="description" type="name" class="form-control" trim="blur" />
      </div>
    </div>

    <div class="form-group row">
      <label class="col-md-3 col-form-label required" for="aclActionType">{{ 'TYPE_OF_ACTION' | translate }}</label>
      <div class="col-md-9">
        <p-select
          [options]="actionType"
          formControlName="aclActionType"
          optionLabel="label"
          trim="blur"
          appendTo="body"
          optionValue="value"
          placeholder="Select Action Type"
          [ngClass]="{ 'error-border': this.messages && this.messages.aclActionType }"
        ></p-select>
        <small *ngIf="this.messages && this.messages.aclActionType" class="input-error-text">
          <span [innerHtml]="this.messages.aclActionType"></span>
        </small>
      </div>
    </div>
  </form>
  <ng-template #footer>
    <button type="button" class="btn btn-primary cancel-btn button-outlined" (click)="closeAddActionDialog()">
      {{ 'CANCEL' | translate }}
    </button>
    <button type="submit" class="btn btn-primary button-filled" (click)="onUpdate(buttonName)">
      {{ buttonName | translate }}
    </button>
  </ng-template>
</p-dialog>

<ng-template #headerTemplate>
  <div>
    <span class="static-text">{{ 'ACTIONS_PERMISSIONS' | translate }}</span>
    <span class="dynamic-text" [innerHTML]="currentTableNameHtml"></span>
  </div>
</ng-template>
